import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bf434c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search flex-col" }
const _hoisted_2 = { class: "order-table" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_4 = {
  key: 0,
  class: "after-sale-rules",
  target: "_blank",
  href: `/ja/iframe/aftersalerules`
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "after-sale-rules-icon",
  src: "https://static-s.theckb.com/BusinessMarket/icon/afterSaleRuleIcon.svg",
  alt: ""
}, null, -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "primary",
  style: {"max-width":"200px"}
}
const _hoisted_8 = { class: "line--2" }

import axios from 'axios'
import { t } from '@/plugins/i18n'
import { ref, reactive, toRaw, computed, nextTick } from 'vue'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import BDialog from './BDialog.vue'
import CDialog from './CDialog.vue'
import ProductSku from '../components/ProductSku.vue'
import { exportFileDownload } from '@/util/useExport'
import { setProdcutLink } from '../data'
import { pageAbnormalOrder } from '@/apis/order'
import { ElMessage, FormInstance } from 'element-plus'
import { getJapanTime, setStartDateTime, setEndDateTime } from '@/util/common'
import {
  afterSalesTableConfig,
  afterSalesProgressDict,
  afterSalesReasonDict,
  d2cAfterSalesColumns,
  b2bAfterSalesColumns
} from './data'
import { useStore } from 'vuex'
import { useRtfix, isD2C, useSite, isJA } from '@/store'
import { useRoute } from 'vue-router'
import dblclick from '@/components/BatchSearch/index'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const route = useRoute()

// 国际发货单号

const store = useStore()

const rowItem = ref({})
const cancelVisible = ref(false)
const openCancelVisible = (row: any) => {
  rowItem.value = row
  cancelVisible.value = true
}
const applyVisible = ref(false)
const openApplyVisible = (row: any) => {
  rowItem.value = row
  applyVisible.value = true
}

const exportLoading = ref(false)
const exportOrder = () => {
  exportLoading.value = true
  axios({
    method: 'POST',
    url: process.env.VUE_APP_URL + '/order/abnormalOrder/exportAfterSalesOrder',
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-AuthShopId': (store.getters['route/getShopId'] || store.getters.curShop) ?? '',
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    data: {
      ...toRaw(form),
      ...toRaw(pageData.value)
    }
  }).then(res => {
    exportFileDownload(res, { name: t('售后') })
  }).finally(() => {
    exportLoading.value = false
    refreshTable()
  })
}
// 打开售后补偿标准
const openAfterSaleMoal = () => {

}

const form = reactive({
  abnormalOrderType: 2,
  productSku: '',
  platformOrderNo: '',
  deliveryTaskCode: '',
  applyAfterSalesStartTime: '',
  applyAfterSalesEndTime: '',
  afterSalesProgress: '',
  afterSalesReason: ''
})

// 消息跳转带参数
if (route.query.deliveryTaskCode) {
  form.deliveryTaskCode = route.query.deliveryTaskCode
}
if (route.query.platformOrderNo3) {
  form.platformOrderNo = route.query.platformOrderNo3
}
const searchDate = computed({
  get: () => [form.applyAfterSalesStartTime, form.applyAfterSalesEndTime],
  set: (newVal) => { [form.applyAfterSalesStartTime, form.applyAfterSalesEndTime] = newVal ?? [] }
})

const filterData = computed(() => {
  return {
    ...form,
    applyAfterSalesStartTime: setStartDateTime(form.applyAfterSalesStartTime),
    applyAfterSalesEndTime: setEndDateTime(form.applyAfterSalesEndTime)
  }
})

const formRef = ref<FormInstance>()

const pageData = ref({
  page: 1,
  limit: 30
})

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  isBatchSearch.value = false
  form.applyAfterSalesStartTime = ''
  form.applyAfterSalesEndTime = ''
  form.platformOrderNo = ''
  form.deliveryTaskCode = ''
  formEl.resetFields()
  refreshTable(true)
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
expose({
  refreshTable
})
const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearchAfterSales', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    abnormalOrderType: 2
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(useSite)())
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        inline: true,
        model: _unref(form)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('平台商品SKU'),
            prop: "productSku"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).productSku,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).productSku) = $event)),
                onDblclick: _cache[1] || (_cache[1] = ($event: any) => {_unref(form).productSku='';_unref(dblclick)('productSkuList')}),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"220px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _unref(t)('THE CKB订单编号')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).platformOrderNo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).platformOrderNo) = $event)),
                    onDblclick: _cache[3] || (_cache[3] = ($event: any) => {_unref(form).platformOrderNo='';_unref(dblclick)('platformOrderNoList')}),
                    placeholder: _unref(t)('双击批量搜索'),
                    style: {"width":"220px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: _unref(t)('国际发货单号')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).deliveryTaskCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).deliveryTaskCode) = $event)),
                    onDblclick: _cache[5] || (_cache[5] = ($event: any) => {_unref(form).deliveryTaskCode='';_unref(dblclick)('deliveryTaskCodeList')}),
                    placeholder: _unref(t)('双击批量搜索'),
                    style: {"width":"220px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('申请售后时间')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _unref(searchDate),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": _unref(t)('开始时间'),
                "end-placeholder": _unref(t)('结束时间'),
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('售后进度'),
            prop: "afterSalesProgress"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(form).afterSalesProgress,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).afterSalesProgress) = $event)),
                class: "w-260"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(afterSalesProgressDict), (k, v) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: v,
                      label: k,
                      value: v
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('售后原因'),
            prop: "afterSalesReason"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(form).afterSalesReason,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).afterSalesReason) = $event)),
                class: "w-260"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(afterSalesReasonDict), (k, v) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: Number(v),
                      label: k,
                      value: Number(v)
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "warning",
                onClick: search
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (resetForm(formRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"margin":"25px 30px 25px 14px"},
          onClick: exportOrder,
          loading: exportLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('导出订单')), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_unref(t)('售后补偿标准')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[10] || (_cache[10] = ($event: any) => ((pageData).value = $event)),
        isImmediatelyExec: false,
        api: _unref(pageAbnormalOrder),
        filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
        columns: _unref(isD2C)() ? _unref(d2cAfterSalesColumns) : _unref(b2bAfterSalesColumns),
        tableConfig: _unref(afterSalesTableConfig),
        onRowClick: _cache[11] || (_cache[11] = (row) => {
        _unref(isD2C)()  ? _ctx.$router.push(_unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId } })) : _ctx.$router.push(_unref(useRtfix)('ShippingInfo', { query: { deliveryTaskCode:row.deliveryTaskCode }}))
      })
      }, {
        afterSalesRefundTotalAmount: _withCtx(({row}) => [
          _createElementVNode("div", null, _toDisplayString(_unref(showCurrentUnit)(row.goodsCountry === _unref(COUNTRY).KR, row.afterSalesRefundTotalAmount)), 1)
        ]),
        platformOrderNo: _withCtx(({row}) => [
          (row.platformOrderId)
            ? (_openBlock(), _createBlock(AppLink, {
                key: 0,
                to: _unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId }})
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.platformOrderNo), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.platformOrderNo), 1))
        ]),
        productSku: _withCtx(({row}) => [
          row
            ? (_openBlock(), _createBlock(ProductSku, {
                key: 0,
                row: row
              }, null, 8, ["row"]))
            : _createCommentVNode("", true)
        ]),
        applyAfterSalesTime: _withCtx(({row}) => [
          _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.applyAfterSalesTime)), 1)
        ]),
        productPropertiesName: _withCtx(({row}) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
            return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
          }), 128))
        ]),
        shoppingInfo: _withCtx(({row}) => [
          _createVNode(ShoppingPreview, {
            image: row.productSkuImg || row.productMainImg || '',
            name: row.productTitleJp,
            url: _unref(setProdcutLink)(row)
          }, null, 8, ["image", "name", "url"])
        ]),
        afterSalesReason: _withCtx(({row}) => [
          _createTextVNode(_toDisplayString(_unref(afterSalesReasonDict)[row.afterSalesReason]), 1)
        ]),
        afterSalesProgress: _withCtx(({row}) => [
          _createTextVNode(_toDisplayString(_unref(afterSalesProgressDict)[row.afterSalesProgress]), 1)
        ]),
        handler: _withCtx(({scope}) => [
          (scope.row.afterSalesProgress == 4)
            ? (_openBlock(), _createBlock(_component_table_button, {
                key: 0,
                title: _unref(t)('重新发起'),
                onClick: _withModifiers(($event: any) => (openApplyVisible(scope.row)), ["stop"])
              }, null, 8, ["title", "onClick"]))
            : _createCommentVNode("", true),
          (scope.row.afterSalesProgress == 1 || scope.row.afterSalesProgress == 5)
            ? (_openBlock(), _createBlock(_component_table_button, {
                key: 1,
                title: _unref(t)('撤销'),
                onClick: _withModifiers(($event: any) => (openCancelVisible(scope.row)), ["stop"])
              }, null, 8, ["title", "onClick"]))
            : _createCommentVNode("", true),
          (scope.row.afterSalesProgress == 0)
            ? (_openBlock(), _createBlock(_component_table_button, {
                key: 2,
                title: _unref(t)('申请售后'),
                onClick: _withModifiers(($event: any) => (openApplyVisible(scope.row)), ["stop"])
              }, null, 8, ["title", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        detailedExplain: _withCtx(({row}) => [
          _createVNode(_component_el_tooltip, {
            placement: "top",
            effect: "light",
            "popper-class": "tool-tip-no-border",
            offset: 10
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(row.detailedExplain), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, _toDisplayString(row.detailedExplain), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["page-data", "api", "filterData", "columns", "tableConfig"]),
      _createVNode(BDialog, {
        title: _unref(t)('撤销售后'),
        visible: cancelVisible.value,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((cancelVisible).value = $event)),
        rowItem: rowItem.value,
        onSuccess: refreshTable
      }, null, 8, ["title", "visible", "rowItem"]),
      _createVNode(CDialog, {
        title: _unref(t)('申请售后'),
        visible: applyVisible.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((applyVisible).value = $event)),
        rowItem: rowItem.value,
        onSuccess: refreshTable
      }, null, 8, ["title", "visible", "rowItem"]),
      _createVNode(BatchSearch, { title: "AfterSales" })
    ])
  ], 2))
}
}

})